module.exports = __webpack_public_path__ + "img/Campine.749b2acf.jpg";